import { z } from 'zod';

export const DeferredEventValue = z.object({
  name: z.string(),
  time: z.string(),
  // Optional record values have been dropped due to JSON.stringify
  value: z.record(z.string(), z.string()),
});
export type DeferredEventValue = z.infer<typeof DeferredEventValue>;
